import _extends from "@babel/runtime-corejs3/helpers/extends";
import * as React from 'react';
var Filler = function Filler(_ref) {
  var height = _ref.height,
    offset = _ref.offset,
    children = _ref.children,
    propsOuterStyle = _ref.outerStyle,
    propsInnerStyle = _ref.innerStyle;
  var outerStyle = {};
  var innerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };
  if (offset !== undefined) {
    outerStyle = _extends({
      height: height,
      position: 'relative',
      overflow: 'hidden',
      zIndex: 0
    }, propsOuterStyle);
    innerStyle = _extends(_extends(_extends({}, innerStyle), {
      transform: "translateY(".concat(offset, "px)"),
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0
    }), propsInnerStyle);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: outerStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: innerStyle
  }, children));
};
export default Filler;